const FORM_STATUSES = {
    inactive: 'Inactive',
    active: 'Active',
    archived: 'Archived',
    deleted: 'Deleted',
    expired: 'Expired',
    communication: 'Communication'
};

const FORM_STATUSES_NAMES = {
    [FORM_STATUSES.inactive]: 'Inactive',
    [FORM_STATUSES.active]: 'Active',
    [FORM_STATUSES.archived]: 'Archived',
    [FORM_STATUSES.expired]: 'Expired',
    [FORM_STATUSES.communication]: 'Communication',
};

export {
    FORM_STATUSES,
    FORM_STATUSES_NAMES
};